import React from 'react';
import { View, ScrollView, StyleSheet } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';

interface DesktopPanelBodyProps {
  children: React.ReactNode;
  scroll?: boolean;
  bottomInset?: number; // extra padding at bottom to avoid footer overlap
}

export const DesktopPanelBody: React.FC<DesktopPanelBodyProps> = ({ children, scroll = false, bottomInset = 0 }) => {
  if (scroll) {
    return (
      <ScrollView
        style={styles.content}
        contentContainerStyle={[styles.contentInner, bottomInset ? { paddingBottom: 16 + bottomInset } : null]}
        showsVerticalScrollIndicator={false}
      >
        {children}
      </ScrollView>
    );
  }
  return <View style={[styles.content, styles.contentInner, bottomInset ? { paddingBottom: 16 + bottomInset } : null]}>{children}</View>;
};

const styles = StyleSheet.create({
  content: {
    flex: 1,
    backgroundColor: ADMIN_COLORS.BACKGROUND.PRIMARY,
  },
  contentInner: {
    paddingHorizontal: 16,
    paddingBottom: 16,
  },
});


